import { Delay, Easing, Sequence } from "../../animation";
import { Animation } from "../../animation/Animation";
import type { IPropsMeta } from "../../defines/ISchema";
import { ease_linearity } from "../../utils/easing/ease_linearity";
import type { IPlayable } from "./IPlayable";
import { UIComponent } from "./UIComponent";

export interface IOpacityFlashProps {
  steps?: number[];
  times?: number;
}
export class OpacityFlash extends UIComponent<IOpacityFlashProps> implements IPlayable {
  static override readonly TAGS: string[] = ["OpacityFlash"];
  static override readonly PROPS: IPropsMeta<IOpacityFlashProps> = {
    steps: {
      key: "steps",
      type: "array",
      items: { type: "number" },
      nullable: true,
      description: "透明度1, 动画时间，透明度2....",
    },
    times: {
      key: "times",
      type: "number",
      nullable: true,
      number: { int: true },
      description: "循环次数，小于0时，无限循环"
    }
  }

  readonly __is_playable__ = true;
  protected _anim: Sequence = new Sequence();
  override on_start(): void {
    super.on_start?.();
    const {
      times = 1,
      steps = [
        0, 350, 1, 100, 1, 350, 0, 350, 1, 100,
        1, 350, 0, 350, 1, 100, 1, 350, 0
      ]
    } = this.props;

    const anims: Animation[] = [];
    for (let i = 1; i < steps.length; i += 2) {
      const prev_o = steps[i - 1];
      const duration = steps[i];
      const next_o = steps[i + 1];
      if (typeof next_o !== 'number') break;
      if (typeof duration !== 'number') break;
      anims.push(
        prev_o === next_o ?
          new Delay(next_o).set_duration(duration) :
          new Easing(prev_o, next_o).set_duration(duration).set_easing(ease_linearity)
      )
    }
    this._anim = new Sequence(...anims)
    this._anim.loop.set_times(times);
  }

  override update(dt: number): void {
    this.node.opacity = this._anim.update(dt).value;
  }

  start(): void {
    this._anim.start(false);
    this.enabled = true;
  }
  stop(): void {
    this.enabled = false;
  }
  replay(): void {
    this._anim.start(false)
    this.enabled = true;
  }
}
